import { motion } from "framer-motion";
import { ArrowDown, ArrowRight } from "lucide-react";
import { MaskLine } from "../lib/motion";
import { scrollToId } from "../lib/lenis";
import { METHOD } from "../content";

const FlowRail = () => (
  <div data-testid="hero-flow-line" className="relative mt-16 md:mt-20">
    <div className="absolute left-0 right-0 top-[5px] h-px bg-inkline" aria-hidden="true" />
    <svg className="absolute left-0 right-0 top-[5px] w-full h-px overflow-visible" aria-hidden="true">
      <line x1="0" y1="0.5" x2="100%" y2="0.5" stroke="#C6FF3D" strokeWidth="1" className="flow-dash" />
    </svg>
    <ol className="relative grid grid-cols-3 md:grid-cols-6 gap-y-6">
      {METHOD.map((m, i) => (
        <motion.li
          key={m.step}
          className="flex flex-col items-start gap-3 pr-3"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 + i * 0.12, duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
        >
          <span className="w-[11px] h-[11px] rotate-45 bg-tinta border-2 border-lima" aria-hidden="true" />
          <span className="label-caps text-muteddark !text-[10px] md:!text-[11px]">{m.title}</span>
        </motion.li>
      ))}
    </ol>
  </div>
);

export const Hero = () => (
  <section
    id="topo"
    data-testid="hero-section"
    className="relative bg-tinta pt-24 md:pt-36 pb-16 md:pb-24 overflow-hidden"
  >
    <div
      className="slash-band -right-24 top-24 w-[420px] h-14 opacity-100 hidden md:block"
      aria-hidden="true"
    />
    <div
      className="slash-band -left-32 bottom-10 w-[360px] h-8 opacity-100 hidden md:block"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <motion.p
        data-testid="hero-eyebrow"
        className="label-caps text-lima mb-6 md:mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.15, duration: 0.6 }}
      >
        Agência brasileira de growth
      </motion.p>

      <h1
        data-testid="hero-title"
        className="headline text-creme text-4xl sm:text-6xl lg:text-[88px] max-w-5xl"
      >
        <MaskLine delay={0.25}>Growth com método.</MaskLine>
        <MaskLine delay={0.4}>
          Resultado com <span className="text-lima">números.</span>
        </MaskLine>
      </h1>

      <motion.p
        data-testid="hero-subtitle"
        className="mt-6 md:mt-8 max-w-2xl text-muteddark text-base md:text-lg leading-relaxed"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.7, ease: [0.25, 1, 0.5, 1] }}
      >
        Tráfego pago, CRM, automação, outbound e time comercial trabalhando em um
        só fluxo, para entregar leads prontos para fechar.
      </motion.p>

      <motion.div
        className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.85, duration: 0.7, ease: [0.25, 1, 0.5, 1] }}
      >
        <button
          data-testid="hero-cta-diagnostico"
          onClick={() => scrollToId("contato")}
          className="bg-lima text-tinta font-sora font-bold text-sm tracking-[-0.02em] px-8 h-12 inline-flex items-center justify-center gap-2 hover:bg-[#d4ff66] transition-colors duration-150"
        >
          Agendar diagnóstico <ArrowRight className="w-4 h-4" />
        </button>
        <button
          data-testid="hero-cta-metodo"
          onClick={() => scrollToId("metodo")}
          className="border border-creme/70 text-creme font-sora font-bold text-sm tracking-[-0.02em] px-8 h-12 inline-flex items-center justify-center gap-2 hover:border-lima hover:text-lima transition-colors duration-150"
        >
          Ver o método <ArrowDown className="w-4 h-4" />
        </button>
      </motion.div>

      <FlowRail />
    </div>
  </section>
);
